// admin/PaymentGatewaySettings.jsx
import React, { useState, useEffect } from "react";
import { getApiUrl } from "../utils/api";
import { toast, ToastContainer } from "react-toastify";

const GATEWAY_OPTIONS = [
  { value: 1, label: "PhonePe Only", color: "#5f259f", icon: "📱" },
  { value: 2, label: "Razorpay Only", color: "#2d81f7", icon: "💳" },
  { value: 3, label: "Both Gateways", color: "#28a745", icon: "✅" },
];

const PaymentGatewaySettings = () => {
  const [activeGateway, setActiveGateway] = useState(1);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const res = await fetch(getApiUrl("payment-settings"), {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        });
        const data = await res.json();
        if (data.success) setActiveGateway(data.data.activeGateway);
      } catch {
        toast.error("Failed to load settings");
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  const handleSave = async (value) => {
    setSaving(true);
    try {
      const res = await fetch(getApiUrl("payment-settings-update"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ activeGateway: value }),
      });
      const data = await res.json();
      if (data.success) {
        setActiveGateway(value);
        toast.success("Payment gateway updated!");
      } else {
        toast.error(data.message);
      }
    } catch {
      toast.error("Update failed");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="text-center mt-5">Loading...</div>;

  return (
    <div className="container mt-4">
      <ToastContainer />
      <h4 className="fw-bold mb-1">Payment Gateway Control</h4>
      <p className="text-muted mb-4">
        Select which payment gateway(s) appear on the checkout page
      </p>

      <div className="row g-3">
        {GATEWAY_OPTIONS.map((opt) => {
          const isActive = activeGateway === opt.value;
          return (
            <div className="col-md-4" key={opt.value}>
              <div
                onClick={() => !saving && handleSave(opt.value)}
                className="card p-4 text-center"
                style={{
                  cursor: saving ? "not-allowed" : "pointer",
                  border: isActive
                    ? `3px solid ${opt.color}`
                    : "2px solid #dee2e6",
                  borderRadius: "16px",
                  background: isActive ? `${opt.color}11` : "#fff",
                  transition: "all 0.2s",
                  transform: isActive ? "scale(1.03)" : "scale(1)",
                  boxShadow: isActive
                    ? `0 4px 20px ${opt.color}44`
                    : "0 2px 8px #0001",
                }}
              >
                <div style={{ fontSize: "40px" }}>{opt.icon}</div>
                <h5
                  className="fw-bold mt-2"
                  style={{ color: isActive ? opt.color : "#333" }}
                >
                  {opt.label}
                </h5>
                {isActive && (
                  <span
                    className="badge mt-2"
                    style={{ background: opt.color, fontSize: "12px" }}
                  >
                    ✓ Active
                  </span>
                )}
              </div>
            </div>
          );
        })}
      </div>

      {/* Status Summary */}
      <div className="card mt-4 p-3 shadow-sm">
        <h6 className="fw-bold mb-2">Current Status</h6>
        <div className="d-flex gap-3">
          <span
            className={`badge fs-6 px-3 py-2 ${[1, 3].includes(activeGateway) ? "bg-success" : "bg-secondary"}`}
          >
            📱 PhonePe: {[1, 3].includes(activeGateway) ? "ON" : "OFF"}
          </span>
          <span
            className={`badge fs-6 px-3 py-2 ${[2, 3].includes(activeGateway) ? "bg-success" : "bg-secondary"}`}
          >
            💳 Razorpay: {[2, 3].includes(activeGateway) ? "ON" : "OFF"}
          </span>
        </div>
      </div>
    </div>
  );
};

export default PaymentGatewaySettings;